import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Alert, Box, Card, CardContent, CircularProgress, Container, Divider, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const money = (value) => `Rs. ${Number(value || 0).toLocaleString()}`;

export default function PublicInvoiceVerification() {
  const { token } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${global.SET_API_URL}kot/public/invoice/${encodeURIComponent(token || '')}`)
      .then((response) => setInvoice(response.data?.data || null))
      .catch((requestError) => setError(requestError?.response?.data?.message || 'Invoice verify nahi ho saka.'));
  }, [token]);

  if (error) return <Container maxWidth="sm" sx={{ py: 5 }}><Alert severity="error">{error}</Alert></Container>;
  if (!invoice) return <Box sx={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Card variant="outlined"><CardContent><Stack spacing={2}>
        <Box textAlign="center"><Typography variant="h4" fontWeight={900}>{invoice.companyName || 'Invoice Verification'}</Typography><Typography color="text.secondary">{invoice.branchName}</Typography></Box>
        <Alert severity="success">Verified invoice — system record mil gaya.</Alert>
        <Stack direction="row" justifyContent="space-between"><Typography>Invoice</Typography><Typography fontWeight={800}>#{invoice.invoiceNo}</Typography></Stack>
        <Stack direction="row" justifyContent="space-between"><Typography>Type</Typography><Typography>{invoice.taxModeEnabled ? `${invoice.taxAuthority || 'Tax'} Invoice` : 'Invoice'}</Typography></Stack>
        <Stack direction="row" justifyContent="space-between"><Typography>Date</Typography><Typography>{new Date(invoice.completedAt || invoice.createdAt).toLocaleString('en-PK')}</Typography></Stack>
        <Stack direction="row" justifyContent="space-between"><Typography>Payment</Typography><Typography>{invoice.paymentMethods || '-'}</Typography></Stack>
        <Divider />
        {(invoice.items || []).map((item) => <Stack key={item.orderItemID} direction="row" justifyContent="space-between"><Typography>{item.itemName} × {Number(item.quantity)}</Typography><Typography>{money(item.itemTotal)}</Typography></Stack>)}
        <Divider />
        {Number(invoice.taxAmount || 0) > 0 && <Stack direction="row" justifyContent="space-between"><Typography>Tax</Typography><Typography>{money(invoice.taxAmount)}</Typography></Stack>}
        <Stack direction="row" justifyContent="space-between"><Typography variant="h6" fontWeight={900}>Total</Typography><Typography variant="h6" fontWeight={900}>{money(invoice.grandTotal)}</Typography></Stack>
        <Typography variant="caption" textAlign="center" color="text.secondary">This is a local invoice verification page. Official authority verification is shown separately when available.</Typography>
      </Stack></CardContent></Card>
    </Container>
  );
}
